import { useState, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export interface IShiftOverride {
  preferredSpecialty: string;
  isAssistedHygiene?: boolean;
  arrivalTime: string;
  departureTime: string;
  mealBreakDuration: string;
  isMealBreakPaid: boolean;
  rate: number | null;
  procedures: string[];
  autoConfirm: { favorites: boolean; eligibleProfessionals: boolean };
}

export interface IShiftDetailsFormValues {
  dates: Date[];
  officeId: string;
  professionType: string;
  preferredSpecialty: string;
  isAssistedHygiene?: boolean;
  arrivalTime: string;
  departureTime: string;
  mealBreakDuration: string;
  isMealBreakPaid: boolean;
  rate: number | null;
  procedures: string[];
  invite: string[];
  inviteNames: Record<string, string>;
  autoConfirm: { favorites: boolean; eligibleProfessionals: boolean };
  shiftOverrides: Record<string, IShiftOverride>;
}

export const useShiftDetailsForm = () => {
  const { control, watch, setValue, getValues, handleSubmit } =
    useFormContext<IShiftDetailsFormValues>();

  const [openField, setOpenField] = useState<string | null>(null);

  const toggleField = useCallback(
    (fieldName: string) => {
      setOpenField((current) => (current === fieldName ? null : fieldName));
    },
    [],
  );

  return {
    control,
    watch,
    setValue,
    getValues,
    openField,
    toggleField,
    handleSubmit,
  };
};
